<template>
    <div class="ui-content dashboard">
        <div class="ui-content dashboard">
            <div class="create-new-test">
                <div class="text-center">
                    <v-btn
                        class="right-btn cust-btn"
                        color="primary"
                        @click="gotoMYTCreateTest()"
                    >
                        Create New Test
                    </v-btn>
                </div>
            </div>
            <v-card class="mx-auto normal-card">
                <div class="data-table-section CustomizedTest">
                    <v-data-table
                        :headers="getHeaders()"
                        fixed-header
                        :items="items"
                        hide-default-header
                        hide-default-footer
                        class="elevation-2 cust-table"
                    >
                        <template v-slot:header="{ props: { headers } }">
                            <TableHeader
                                :headers="getHeaders()"
                                :onHeaderAction="onHeaderAction"
                                :orderBy="orderBy"
                                :onSortChange="onSortChange"
                            />
                        </template>
                        <template v-slot:body="{ items }">
                            <tbody>
                                <tr v-if="items.length === 0">
                                    <td colspan="7" class="text-center">
                                        No test found
                                    </td>
                                </tr>
                                <tr
                                    v-else
                                    style="position:relative"
                                    v-for="item in items"
                                    :key="item.id"
                                >
                                    <td class="text-left">
                                        {{ item.test_name }}
                                    </td>
                                    <td class="duration-display">
                                        {{ item.duration }}
                                    </td>

                                    <td class="">
                                        {{ getDate(item) }}
                                    </td>
                                    <td class="text-left">
                                        {{ item.target_name }}
                                    </td>
                                    <td class="text-left">
                                        {{ item.pattern }}
                                    </td>
                                    <td class="text-center">
                                        {{ item.subjects }}
                                    </td>
                                    <td class="text-center">
                                        <div
                                            class="cursor_click"
                                            :class="
                                                getCreateTestStatusClass(item)
                                            "
                                            @click="gotoTest(item)"
                                        >
                                            {{
                                                getTestCreationStatusText(item)
                                            }}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-data-table>
                </div>
            </v-card>
            <div class="footer-btn">
                <div class="pull-left"></div>
                <div class="pull-right">
                    <Pagination
                        :currentPage="currentPage"
                        :totalPage="totalPages"
                        :onPageChange="onPageChange"
                    />
                </div>
            </div>
            <AlertBox
                :width="modalwidth"
                :onClose="onClose"
                :component="cComponent"
                :status="status"
                :data="alertBoxData"
            />
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";
import { detect } from "detect-browser";
import { showUpgradeModal } from "@/utils/upgradeUtils.js";
let timeInterval = null;
export default {
    name: "CreateTestCustomized",
    data() {
        return {
            orderBy: {
                field: "created_at",
                order: "DESC",
            },
            currentPage: 1,
            pageSize: 10,
            totalPages: 1,
            targets: [],

            items: [],
            dialog: false,
            cComponent: "components/coordinator/Tests/ScheduleTestPopup",
            status: false,
            alertBoxData: {},
            selectedTest: null,
            modalwidth: "1000px",
            instituteType: "SILVER",
            currentTestName: "",
            testName: "",
            modules: [],
            dummyOptions: [],
            dummyOptionsABC: [],
            dummyOptionsPQR: [],
            retryTestData: {},
            timeInterval: 0,
            TEST_STATUS: {},
            buttonHovering: false,
            showToolTip: false,
            hover: false,
            typetimeout: 0,
            selectedTarget: [],
             hasMasterPyqModule: false
        };
    },

    async mounted() {
        if(!(this.user && this.user.subscription_details)){
           await this.delayTime(1000);
        }
        this.defaultData();
        this.browserInfo = detect();
        this.checkStudentUpgraded();
         this.checkMasterPyqModule();
    },
    computed: {
        ...mapState("userStore", ["user"]),
    },
    methods: {
        ...mapActions({
            getTestTarget: "utilStore/getTestTarget",
            checkTestStatus: "testStore/checkTestStatus",
            getTestList: "testStore/getTestList",
            customTestRetry: "testStore/customTestRetry",
        }),

        checkSessionData() {
            let rp = this.$route; // route params
            let crd = this.getCurrentRouteDetails(rp.name);

            if (rp.params.resetPage || !crd.routeName) {
                let routeDetails = {
                    routeName: rp.name,
                    selectedTab: "default",
                    tabDetails: {
                        default: {
                            page: 1,
                            orderBy: this.orderBy,
                        },
                    },
                };
                this.setRouteDetails(routeDetails);
            }
        },
        checkMasterPyqModule() {
    const userDetails = this.user || JSON.parse(localStorage.getItem('user') || '{}');

    if (userDetails?.institute === constants.ONLINE_INSTITUTE_ID) {

        const subscriptionDetails = userDetails.subscription_details || [];

           const MASTER_PYQ_IDS = [
        constants.MODULES.MASTERPYQJEE26,
        constants.MODULES.MASTERPYQJEE27,
        constants.MODULES.MASTERPYQNEET26,
        constants.MODULES.MASTERPYQNEET27
    ].map(Number);

    const masterPyqSub = subscriptionDetails.find(
        sub => sub.name === "MASTERPYQPREMIUM"
    );

    this.hasMasterPyqModule = Boolean(
        masterPyqSub &&
        Array.isArray(masterPyqSub.product_id) &&
        masterPyqSub.product_id
            .map(Number)          
            .some(id => MASTER_PYQ_IDS.includes(id))
    );
    } else {

        const moduleDetails = JSON.parse(localStorage.getItem('modules') || '[]');
        this.hasMasterPyqModule = moduleDetails.some(
            mod => mod.module_id === constants.MODULES.BOOSTUP
        );
    }
}
,
        defaultData() {
            this.checkSessionData();
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);
            if (crd) {
                this.currentPage = crd.tabDetails[crd.selectedTab].page;
                this.orderBy = crd.tabDetails[crd.selectedTab].orderBy;
            }
            if (this.compareEvent(constants.EVENT.CREATE_PRACTICE_SESSION)) {
                this.removeEvent()
                this.requestCreateTest();
            }
            this.requestGetTestList();
            this.reqGetTestTargets();
        },
        getDate(item) {
            return moment(item.created_at).format("DD/MM/YYYY");
        },
        requestGetTestList() {
            if ((!this.checkStudentUpgraded() )) {

                let reqData = {
                    test_types: [5],
                    test_sub_types: [this.TEST_SUB_TYPES.MYT],
                    orderBy: this.orderBy,
                    pagination: {
                        page: this.currentPage,
                        pageSize: this.pageSize,
                    },
                    test_name: this.testName,
                };
                this.$root.showLoader = true;
                if (this.selectedTarget && this.selectedTarget.length) {
                    reqData.targets = this.selectedTarget;
                }
                this.getTestList(reqData)
                    .then((response) => {
                        if (
                            response.list.length == 0 &&
                            this.currentPage != 1 &&
                            !this.$route.query.resetPage
                        ) {
                            this.onPageChange(1);
                            return;
                        }
                        this.items = response.list.map((l) => {
                            l.editTestName = false;
                            return l;
                        });
                        this.setIntervalTime();
                        this.totalPages = response.pagination.pageCount;
                        this.$root.showLoader = false;
                    })
                    .catch((err) => {
                        this.$root.showLoader = false;
                    });
                }
        },
        checkStudentUpgraded() {
            const modules = JSON.parse(localStorage.getItem("modules")) || [];
            let boostUpModule;
            if(this.user.institute !== constants.ONLINE_INSTITUTE_ID){
                boostUpModule = modules.find(m => m.module_id === 10);
                if(boostUpModule){
                    return false;
                }
            }
            
            this.status = this.checkStudentUpgradedHelper(
                this.user.subscription_details
            );
            if (this.status) {
                showUpgradeModal(this);
            }
            return this.status;
    },

        onHeaderAction(e) {
            if (e.header && e.header.type === "multidropdown") {
                this.selectedTarget = e.data.selectedItems;
            }
        },
        onSortChange() {
            this.requestGetTestList();
        },
        onPageChange(e) {
            this.currentPage = e;
            this.requestGetTestList();
        },
        gotoMYTCreateTest(isDummy) {
            if((this.checkStudentUpgraded() )){
            return;
            }
                this.$router.push({ name: "create-MYT-tests" });
        },
        
        gotoTest(test) {
            if (
                this.checkBrowserSupport() &&
                test.test_create_status === constants.CUSTOM_TEST_STATUS.CREATED
            ) {
				let routeName = this.$route.name;
				localStorage.setItem("previousRoute", routeName);
                if(this.user.role_id == this.roleIds.PA){
                    if(!test.test_schedule_id){
                        this.selectedTest = test;
                        this.cComponent =
                            "components/coordinator/Tests/ScheduleTestPopup";
                        this.modalwidth = "1000px";
                        this.status = true;
                        this.alertBoxData = { selectedTest: this.selectedTest };
                    }
                }else{
                    sessionStorage.removeItem('changedTab')
                    localStorage.setItem("previousPath", this.$route.path);
                    this.$router.push({
                        name: "instructions-about-test",
                        params: {
                            test_id: test.id,
                            test_institute_id: test.test_institute_id,
                        },
                    });
                }
            } else if (
                test.test_create_status ==
                    constants.CUSTOM_TEST_STATUS.FAILED ||
                (test.test_create_status ===
                    constants.CUSTOM_TEST_STATUS.IN_PROGRESS &&
                    this.timeComparison(test))
            ) {
                const reqData = {
                    test_id: test.id,
                };
                this.customTestRetry(reqData)
                    .then((response) => {
                        if (
                            response.code !== 102 ||
                            response.retry_request_data
                        ) {
                            this.retryTestData = response.retry_request_data;
                            this.createCustomTest();
                        } else {
                            let index = this.items.findIndex(
                                (t) => t.id === reqData.test_id
                            );
                            if (index >= 0) {
                                this.items[index].test_create_status =
                                    constants.CUSTOM_TEST_STATUS.IN_PROGRESS;
                            }
                            this.setIntervalTime();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
            else if(!this.checkBrowserSupport() && test.test_create_status === constants.CUSTOM_TEST_STATUS.CREATED){
                this.showBrowserMessage();
            }
        },
        checkBrowserSupport() {
            if (!this.browserInfo || !this.browserInfo.name) return false;
            let browserName = this.browserInfo.name;
            let nAgent = navigator.userAgent.toLowerCase();
            let isSupported = true;
            this.UNSUPPROTED_BROWSERS.forEach((browser) => {
                if (nAgent.includes(browser)) {
                    isSupported = false;
                }
            });

            if (
                isSupported &&
                (browserName == "firefox" ||
                    browserName == "chrome" ||
                    browserName == "safari" ||
                    browserName == "crios" ||
                    browserName == "fxios" ||
                    browserName == "ios"
                  )
            ) {
                return true;
            }
            return false;
        },
        showBrowserMessage() {
            this.cComponent = "components/common/BrowserSupport";
            this.modalwidth = "700px";
            this.status = true;
            this.alertBoxData = { persistent: false };
        },
        reqGetTestTargets() {
            this.getTestTarget({})
                .then((response) => {
                    this.loading = false;
                    this.targets = response.map((x) => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.id;
                        c.checked = false;
                        return c;
                    });
                    this.targets = this.targets.filter(t=>t.value != 4)
                    
                    // Determine target exam group based on user's target exam
                    const targetExamId = this.user && this.user?.target_exam?.exam_id ? this.user.target_exam.exam_id : null;
                    let targetGroup = null;
                    
                    if (targetExamId === constants.TARGET_EXAM_GROUPS.MEDICAL) {
                        targetGroup = constants.TARGET_EXAM_GROUPS.MEDICAL;
                    } else if (targetExamId === constants.TARGET_EXAM_GROUPS.ENGINEERING) {
                        targetGroup = constants.TARGET_EXAM_GROUPS.ENGINEERING;
                    }
                    
                    // Filter targets based on target group for online institute
                    if(this.user.institute === constants.ONLINE_INSTITUTE_ID){
                        if (targetGroup === constants.TARGET_EXAM_GROUPS.MEDICAL) {
                            this.targets = this.targets.filter((t) => t.value == constants.TARGET_EXAMS.NEET);
                        } else if (targetGroup === constants.TARGET_EXAM_GROUPS.ENGINEERING) {
                            this.targets = this.targets.filter((t) => t.value == constants.TARGET_EXAMS.JEE_MAIN);
                        }
                    } else if(this.user.role_code === 'ST' && this.user.institute !== constants.ONLINE_INSTITUTE_ID){
                        this.targets = this.targets.filter((t) => t.value == constants.TARGET_EXAMS.NEET || t.value == constants.TARGET_EXAMS.JEE_MAIN);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        getHeaders() {
            return [
                {
                    text: "Test Name",
                    value: "test_name",
                    class: "text-left",
                },
                {
                    text: "Duration\n(Mins)",
                    align: "center",
                    value: "duration-display",
                    class: "text-center",
                    hideSort: true,
                },
                { text: "Created On", value: "created_at", class: "" },
                {
                    text: "Target Exam",
                    value: "target_exam",
                    type: "multidropdown",
                    options: this.targets,
                    allText: "All Target Exam",
                    text: "Target Exam",
                    class: "text-left",
                },
                {
                    text: "Pattern",
                    value: "pattern",
                    class: "text-left",
                    hideSort: true,
                },
                {
                    text: "Subjects",
                    value: "subjects",
                    class: "text-center",
                    hideSort: true,
                },
                { text: "", value: "", type: "blank", class: "" },
            ];
        },
        setIntervalTime() {
            if (!timeInterval) {
                timeInterval = setInterval(() => {
                    let test_ids = [];
                    this.items.map((t) => {
                        if (
                            t.test_create_status ==
                            constants.CUSTOM_TEST_STATUS.IN_PROGRESS
                        ) {
                            test_ids.push(t.id);
                        }
                    });
                    if (test_ids.length > 0) {
                        this.getTestStatus(test_ids);
                    } else {
                        clearInterval(timeInterval);
                        timeInterval = null;
                    }
                }, 5000);
            }
        },
        getTestStatus(ids) {
            const reqData = {
                test_ids: ids,
            };
            this.checkTestStatus(reqData)
                .then((response) => {
                    this.items.map((t) => {
                        let testStatus = response.find((r) => r.id === t.id);
                        if (testStatus && testStatus.test_create_status) {
                            t.test_create_status =
                                testStatus.test_create_status;
                        }
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        createCustomTest(questions, optionalQuestionsList, confirmation) {
            //this.retryTestData.list = this.getQuestionArray(this.retryTestData.list);
            let list = this.createRetryQuestionData(this.retryTestData);
            let forUpdate = false;

            let reqData = { ...this.retryTestData };
            (reqData.test_pattern = 1), (reqData.list = list);
            reqData.allowed_dummy_question = true;
            // }
            this.customTestRetry(reqData)
                .then((response) => {
                    this.$toasted.success(` ${response.msg}`);
                    let index = this.items.findIndex(
                        (t) => t.id === reqData.test_id
                    );
                    if (index >= 0) {
                        this.items[index].test_create_status =
                            constants.CUSTOM_TEST_STATUS.IN_PROGRESS;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        setIntervalTime() {
            if (!timeInterval) {
                timeInterval = setInterval(() => {
                    let test_ids = [];
                    this.items.map((t) => {
                        if (
                            t.test_create_status ==
                            constants.CUSTOM_TEST_STATUS.IN_PROGRESS
                        ) {
                            test_ids.push(t.id);
                        }
                    });
                    if (test_ids.length > 0) {
                        this.getTestStatus(test_ids);
                    } else {
                        clearInterval(timeInterval);
                        timeInterval = null;
                    }
                }, 5000);
            }
        },
        getAnswerType(questionType, subtype) {
            let answerType = 0;

            if (
                questionType == this.QUE_TYPES.COMPREHENSION ||
                questionType == this.QUE_TYPES.TC
            ) {
                answerType = 0; // for questions with subtypes
                if (
                    subtype == this.QUE_TYPES.TC_2Q_SA ||
                    subtype == this.QUE_TYPES.COMPREHENSION_2Q_SA ||
                    subtype == this.QUE_TYPES.COMPREHENSION_2Q_MM ||
                    subtype == this.QUE_TYPES.COMPREHENSION_2Q_MA ||
                    subtype == this.QUE_TYPES.COMPREHENSION_2Q_NU
                ) {
                    this.subQuestionLength = 2;
                } else if (
                    subtype == this.QUE_TYPES.COMPREHENSION_3Q_MA ||
                    subtype == this.QUE_TYPES.COMPREHENSION_3Q_SA ||
                    subtype == this.QUE_TYPES.TC_3Q_SA
                ) {
                    this.subQuestionLength = 3;
                }
            } else if (
                questionType == this.QUE_TYPES.ASSERTION_REASON ||
                questionType == this.QUE_TYPES.MULTIPLE_CORRECT ||
                questionType == this.QUE_TYPES.SINGLE_CORRECT
            ) {
                answerType = 1; // for questions options
            } else if (
                questionType == this.QUE_TYPES.MATRIX_MATCH_OPTION ||
                questionType == this.QUE_TYPES.MATRIX_MATCH
            ) {
                answerType = 2; // for questions with options, optionsabc, optionspqr
            } else if (questionType == this.QUE_TYPES.SUBJECTIVE || questionType == this.QUE_TYPES.SUBJECTIVEINTEGER) {
                answerType = 3; // for subjective type questions
            } else if (questionType == this.QUE_TYPES.INTEGER) {
                answerType = 4; // for integer type questions
            }
            return answerType;
        },
       
        retryTestDialog(item) {
            if (
                item.test_create_status !== constants.CUSTOM_TEST_STATUS.FAILED
            ) {
                return;
            } else {
                const reqData = {
                    test_id: item.id,
                };
                this.customTestRetry(reqData)
                    .then((response) => {
                        if (
                            response.code !== 102 ||
                            response.retry_request_data
                        ) {
                            this.retryTestData = response.retry_request_data;
                            this.createCustomTest();
                        } else {
                            let index = this.items.findIndex(
                                (t) => t.id === reqData.test_id
                            );
                            if (index >= 0) {
                                this.items[index].test_create_status =
                                    constants.CUSTOM_TEST_STATUS.IN_PROGRESS;
                                this.items[index].updated_at = moment().format(
                                    "YYYY-MM-DDTHH:mm:ss"
                                );
                            }
                            this.setIntervalTime();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        getTestCreationStatusText(item) {
            if(item.test_schedule_id){
                return "Scheduled";
            }else if (
                item.test_create_status === constants.CUSTOM_TEST_STATUS.CREATED
            ) {
                return this.user.role_id == this.roleIds.PA ? "Schedule" : "Attempt";
            } else if (
                item.test_create_status ===
                    constants.CUSTOM_TEST_STATUS.IN_PROGRESS &&
                this.timeComparison(item)
            ) {
                return "In Progress";
            } else if (
                item.test_create_status === constants.CUSTOM_TEST_STATUS.FAILED
            ) {
                return "Retry";
            } else {
                return "Retry";
            }
        },
        getCreateTestStatusClass(item) {
            if (
                item.test_create_status === constants.CUSTOM_TEST_STATUS.CREATED
            ) {
                return this.user.role_id == this.roleIds.PA ? '': "attempt-color";
            } else if (
                item.test_create_status ===
                    constants.CUSTOM_TEST_STATUS.IN_PROGRESS &&
                this.timeComparison(item)
            ) {
                return "green-text";
            } else {
                return "red-text";
            }
        },
        timeComparison(item) {
            let now = moment(),
                updated_at = moment(item.updated_at).add("25", "minutes");
            now = new Date(now);
            updated_at = new Date(updated_at);
            return now < updated_at;
        },
        onClose(data){
            this.status=data.status;
            
            // Handle upgrade confirmation modal response
            if (data.openPaymentModal) {
                this.cComponent = 'components/student/UpgradeToGold/GstChargesPopUp';
                this.modalwidth = '500px';
                this.status = true;
                this.alertBoxData = data.paymentData;
                return;
            }
            
            if(data.realodTest){
                this.requestGetTestList();
            }
        },



    },
    watch: {
        selectedTarget(val) {
            if (val) {
                this.requestGetTestList();
            }
        },
    },
    beforeDestroy() {
        clearInterval(timeInterval);
        timeInterval = null;
    },
};
</script>
